export default __webpack_public_path__ + "static/media/208-mark.a66d4ee2.svg";